/**
 * Created by piotr.pozniak@thebeaverhead.com on 08/03/2019.
 */

import React from "react";
import classNames from "classnames";

/**
 *
 * @param {string} title
 * @param {string} icon
 * @param {Boolean=true} showBottomBorder
 * @returns {React.JSX.Element}
 * @constructor
 */
const DetailsRow = ({ icon, title, children, showBottomBorder = true }) => {
  const titleBlock = title ? (
    <div className="col-content__title">
      <h3 className="">{title}</h3>
    </div>
  ) : null;
  return (
    <div className={"event-row--details"}>
      <div
        className={classNames("event-row--details-row", {
          "event-row--details-row_no-border": !showBottomBorder,
        })}
      >
        <div className="col-icon">
          <i className="material-icons">{icon}</i>
        </div>
        <div className="col-content ">
          {titleBlock}
          <div className="col-content__body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default DetailsRow;
